import * as Yup from 'yup';

export const AppointmentSchema = Yup.object().shape({
  hospitalId: Yup.number()
    .required('Hastane seçimi zorunludur')
    .nullable()
    .test('not-null', 'Hastane seçimi zorunludur', value => value !== null),
  personId: Yup.number()
    .required('Kişi seçimi zorunludur')
    .nullable()
    .test('not-null', 'Kişi seçimi zorunludur', value => value !== null),
  appointmentDate: Yup.date().required('Randevu tarihi zorunludur'),
  appointmentStartTime: Yup.string().required('Randevu başlangıç saati zorunludur'),
  appointmentEndTime: Yup.string()
    .required('Randevu bitiş saati zorunludur')
    .test('end-after-start', 'Bitiş saati başlangıç saatinden sonra olmalıdır', function (value) {
      const { appointmentStartTime } = this.parent;
      if (!value || !appointmentStartTime) return true;
      return value > appointmentStartTime;
    }),
  deviceList: Yup.string()
    .required('Cihaz listesi zorunludur')
    .min(1, 'Cihaz listesi zorunludur'),
});

